import * as React from "react";
const SvgSend20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M.018 6.811 19.838.163l-6.65 19.82-4.432-8.74L.018 6.812Zm10.702 3.883 2.091 4.124 3.138-9.353-5.23 5.23Zm3.814-6.643-5.229 5.23-4.123-2.092 9.352-3.138Z",
      clipRule: "evenodd"
    })
  );
export default SvgSend20Px;
